window.mobileAndTabletcheck = function () {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

/*
 *   Custom jQuery
 */
//text maxlength counter for inputs and textareas
function counter(e) {
    var c = e.parent().parent().find('.count');
    var arr = c.text().match(/\d+/g);

    if (arr[0] / arr[1] >= .8) {
        c.css({
            'color': 'red',
            'font-weight': 'bold'
        });
    } else if (arr[0] / arr[1] >= .6 && arr[0] / arr[1] < .8) {
        c.css({
            'color': '',
            'font-weight': 'normal'
        });
    } else {
        c.css({
            'color': '',
            'font-weight': 'normal'
        });
    }
}

function countLineBreaks(v) {
    var newLines = v.match(/(\r\n|\n|\r)/g);
    var addition = 0;
    if (newLines !== null) {
        addition = newLines.length;
        return addition;
    } else {
        return 0;
    }
}

function plmExpandClose(e, t) {
    e.stopPropagation();
    t.hide();
    t.siblings('.count').hide();
    t.siblings('.edit-cursor').show();
    t.siblings('textarea').removeClass('expanded').width('');
    $('.plm-notes-expand .plm-notes-preview').show();
    replaceLineBreaks(t.siblings('input'), t.siblings('textarea'));
    t.parent().removeClass('expanded');
}

function replaceLineBreaks(e, t) {
    var te = t.val();
    e.val(te.replace(/[\r\n]+/g, '\xa0\xa0'));
}

function replaceSpaceWithLineBreaks(e, t) {
    var ti = t.val();
    e.val(ti.replace(/\xa0\xa0/g, "\n"));
}

$(function () {
    $(document).on('click', function (e) {
        if ($('.plm-notes-expand').find('.expanded').length > 0) {
            var t = $('.plm-notes-expand .expanded');
            plmExpandClose(e, t.siblings('.close'));
        }
    });

    $('body').on('click touchstart focus', '.plm-notes-expand', function (e) {
        var $t = $(this);
        if ($t.find('.expanded').length === 0) {
            e.preventDefault();
            $('.plm-notes-expand.expanded .close').click();
            $('.plm-notes-expand .plm-notes-preview').hide();
            replaceSpaceWithLineBreaks($t.children('textarea'), $t.children('input'))
            //close all before opening new
            var t = $t.find('.close');
            var ww = $(window).width();
            plmExpandClose(e, t);
            
            //show the new one, make 70% wide of parent field
            $t.addClass('expanded');
            $t.parents('.ui-grid-cell').addClass('expanded');
            $t.find('textarea').removeAttr('disabled').addClass('expanded').width(ww * 0.7);
            
            var text = $t.find('textarea').val();
            $t.find('textarea').focus();

            setTimeout(function () {
                $t.find('textarea').val('');
                $t.find('textarea').val(text);
            }, 50);
            
            $t.find('.edit-cursor').hide();
            $t.find('.close').show();
            $t.find('.count').show();
        } else {
            e.stopPropagation();
        }
    });

    $('body').on('keyup', '.wrapper.edit textarea, textarea.expanded', function () {
        var $t = $(this);
        counter($t);
    });
    
    $('body').on('click touchstart', '.plm-notes-expand .close', function (e) {
        var t = $(this);
        plmExpandClose(e, t);
    });

    $('body').on('click', 'label', function () {
		
        if ( !$(this).attr('ng-click') && $(this).prev().attr('type') !== 'file' && !$(this).attr('for') ) {
        	$(this).prev().click();
        }
    })

    $('body').on('click', '.themes > a', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', '.user .themes > a', function () {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
        } else {
            $(this).parent().addClass('active');
        }
    });

    $(document).on('click', function (e) {
        if ($('.user .themes.active').length > 0) {
            $('.user .themes.active').removeClass('active');
        }
    })

    $(document).on('click', 'body', function () {
        if ($('#mainNav').hasClass('open')) {
            $('#mainNav').removeClass('open');
        }
    });

    $(document).on("click", '#mobileNavButton', function (e) {
        e.stopPropagation();
        $('#mainNav').toggleClass('open');
        $(this).toggleClass('open');        
    });

    //Menu icon section 
    $('body').on('click','#actions', function(event) {
        var el = $(".sticky-box");
        if (el.css("display") === "block") {
            el.css("display", "none");
        } else {
            el.css("display", "block");
        }
        event.stopPropagation();
    });

    $('body').on('click', '.imagewrap .image', function () {
        var bg = $(this).children('img').attr('data-full');
        $('#theImage').attr('src', bg);
        $('#imagePopup').modal('toggle');
    });

    $('#imagePopup').on('hidden.bs.modal', function () {
        $('#theImage').attr('src', "");
    })

    function scrollFixed() {
        var ww = $('.cp-table').length > 0 ? 1200 : 1050;
        if ($(window).width() > ww) {
            if ($(window).scrollTop() > 0) {
                $('.row.scroll-fixed').addClass('active');
            } else {
                $('.row.scroll-fixed').removeClass('active');
            }
        }
    } scrollFixed();

    $(window).scroll(function () {
        scrollFixed();
    });
   
    // Collapse ibox function
    $('.collapse-link').click( function() {
        var ibox = $(this).closest('div.ibox');
        var button = $(this).find('i');
        var content = ibox.find('div.ibox-content');
        content.slideToggle(200);
        button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        setTimeout(function () {
            ibox.resize();
            ibox.find('[id^=map-]').resize();
        }, 50);
    });

    $('bs-datepicker').datepicker({
        assumeNearbyYear: true
    })

    // Close ibox function
    $('.close-link').click( function() {
        var content = $(this).closest('div.ibox');
        content.remove();
    });

    // Small todo handler
    $('.check-link').click( function(){
        var button = $(this).find('i');
        var label = $(this).next('span');
        button.toggleClass('fa-check-square').toggleClass('fa-square-o');
        label.toggleClass('todo-completed');
        return false;
    });

    // Tooltips demo
    $('.tooltip-demo').tooltip({
        selector: "[data-toggle=tooltip]",
        container: "body"
    });

    $(window).resize(function () {
        if ($('.plm-notes-expand.expanded')) {
            $('.plm-notes-expand.expanded textarea').width($(window).width() * 0.7);
        }
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('#scrollup,#hide,#show').fadeIn();
            //$("#header-scroll").slideUp();
        } else {
            $('#scrollup,#hide,#show').fadeOut();
            //$("#header-scroll").slideDown();
        }
    });

});

$(document).on('click touchstart', '.up', function () {
    $("body,html").animate({ scrollTop: 0 }, 100);
    return false;
});

// check if browser support HTML5 local storage
function localStorageSupport() {
    return (('localStorage' in window) && window['localStorage'] !== null);
}
// Dragable panels
function WinMove() {
    var element = "[class*=col]";
    var handle = ".ibox-title";
    var connect = "[class*=col]";
    $(element).sortable(
        {
            handle: handle,
            connectWith: connect,
            tolerance: 'pointer',
            forcePlaceholderSize: true,
            opacity: 0.8
        })
        .disableSelection();
}

function myFunction() {
    document.getElementById("htsopen").style.display = "block";
}
